"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ol = require("openlayers");
exports.osmLayer = new ol.layer.Tile({
    source: new ol.source.OSM()
});
exports.ktimaLayer = new ol.layer.Tile({
    source: new ol.source.TileWMS({
        url: 'http://gis.ktimanet.gr/wms/wmsopen/wmsserver.aspx?',
        params: { 'SRS': 'EPSG:900913', 'FORMAT': 'jpeg', 'LAYERS': 'basic', 'TILED': true },
        serverType: 'mapserver',
        projection: 'EPSG:900913'
    })
});
var projection = ol.proj.get('EPSG:900913');
var projectionExtent = projection.getExtent();
var tileSize = 256;
var resolutions = [156543.03, 78271.52, 39135.76, 19567.87924, 9783.939619, 4891.96981, 2445.984905, 1222.992452, 611.4962262, 305.7481131, 152.8740565, 76.43702827, 38.21851414, 19.10925707, 9.554628534, 4.777314267, 2.388657134, 1.194328567, 0.5971642835];
exports.tnLayer = new ol.layer.Tile({
    source: new ol.source.XYZ({
        url: "http://5.135.161.95/wms/wmsolv3xyz2.php?z={z}&x={x}&y={y}&t=15",
        crossOrigin: undefined
    })
});
exports.bingAerialLayer = new ol.layer.Tile({
    source: new ol.source.BingMaps({
        key: 'AnOH4hX_YaNwHAdisvgGuUAGcEXxFYE2TwJsswR-vZTSEaTHffULolihVlFpIhjv',
        imagerySet: 'Aerial'
    })
});
//  if(url=='bing'){
//             var styles = [
//                 'Road',
//                 'Aerial',
//                 'AerialWithLabels',
//                 'collinsBart',
//                 'ordnanceSurvey'
//             ];
//             this.mspService.map().olMap.removeLayer(this.mspService.map().activeBaseLayer)
//             this.mspService.map().activeBaseLayer = new ol.layer.Tile({
//                 source: new ol.source.BingMaps({
//                     key: 'AnOH4hX_YaNwHAdisvgGuUAGcEXxFYE2TwJsswR-vZTSEaTHffULolihVlFpIhjv',
//                     imagerySet: styles[1]
//                 })
//             })
//             this.mspService.map().olMap.getLayers().insertAt(0, this.mspService.map().activeBaseLayer);
//         }else {
//             //if (this.mspService.map().activeBaseLayer.getSource().urls != null)
//                 //if (this.mspService.map().activeBaseLayer.getSource().urls[0] != url) {
//                     this.mspService.map().olMap.removeLayer(this.mspService.map().activeBaseLayer)
//                     this.mspService.map().activeBaseLayer = new ol.layer.Tile({
//                         source: new ol.source.XYZ({
//                             url: url
//                             , crossOrigin: null
//                         })
//                     });
//                     this.mspService.map().olMap.getLayers().insertAt(0, this.mspService.map().activeBaseLayer);
//                 //}
//         }
//  { label: "cartocdn (clean)", value: "http://a.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png" },
//             { label: "cartocdn (labels)", value: "http://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png" },
//             { label: "Topoguide EL", value: "http://5.135.161.95/wms/wmsolv3xyz2.php?z={z}&x={x}&y={y}&t=15" },
//             { label: "Topoguide EN", value: "http://5.135.161.95/wms/wmsolv3xyz2.php?z={z}&x={x}&y={y}&t=16" },
//             { label: "Cycle Map", value: "http://{a-c}.tile.opencyclemap.org/cycle/{z}/{x}/{y}.png" },
//             { label: "Transport Map", value: "http://{a-c}.tile.thunderforest.com/transport/{z}/{x}/{y}.png" },
//             { label: "OSM ​Mountain Bike Open", value: "http://tile.mtbmap.cz/mtbmap_tiles/{z}/{x}/{y}.png" },
//             { label: "OD ​Outdoors Open", value: "https://a.tile.thunderforest.com/outdoors/{z}/{x}/{y}.png" },
//             { label: "Bing", value: "bing" }
// export const tnLayer = new ol.layer.Tile({
//     source: new ol.source.XYZ({
//         url: 'http://5.135.161.95/wms/wmsolv3xyz2.php?z={z}&x={x}&y={y}&t=15',
//         crossOrigin: 'null',
//         projection: projection,
//         tileGrid: new ol.tilegrid.TileGrid({
//             origin: ol.extent.getTopLeft(projectionExtent),
//             resolutions: resolutions,
//             tileSize: 256
//         })
//     })
// }); 



//////////////////
// WEBPACK FOOTER
// ./node_modules/ol-map-printable/dist/layer.list.js
// module id = 3
// module chunks = 0